<template>
	<div class="d-flex w-100">
		<Loading v-if="loading === true" class="mt-5 pt-4"/>
		<table
				class="table table-standard table-sm table-cash-states"
				v-if="loading === false"
		>
			<thead>
				<tr>
					<th>Stratégia</th>
					<th>Stav účtu</th>
					<th>Mena</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in items">
					<td>{{ item.strategy }}</td>
					<td>{{ item.amount }}</td>
					<td>{{ item.currency }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Loading from "./Loading";

export default {
	name: "CashStates",
	components: {Loading},
	mounted() {
		this.$store.dispatch("assets/cashState");
	},
	computed: {
		items() {
			return this.$store.state.assets.cashStates;
		},
		loading() {
			return this.$store.state.assets.loadingCashStates;
		}
	}
};
</script>

<style lang="scss">
	.table-cash-states {
		font-size: 11.5px !important;

		td {
			white-space: nowrap;
		}
	}
</style>
